import React from 'react';

/**
 * Contagem do resultado, entre os filtros e a lista (padrão do Hilton, 02/09/2026).
 *
 * Texto único em todo o sistema: **"Encontrados: X de Y itens"** — sempre "itens", qualquer
 * que seja o registro. Antes cada tela escrevia o seu ("468 pacientes encontrados", "59 de 59
 * usuários"), com ordem e palavra diferentes, e o usuário reaprendia a ler a cada página.
 *
 * `shown` é quanto o filtro deixou passar; `total` é o que existe sem filtro. Onde a
 * paginação é do servidor não há como saber o total sem filtro — aí `total` fica de fora e o
 * texto cai para "Encontrados: X itens", sem inventar um número.
 */
interface ResultCountProps {
  shown: number;
  total?: number;
}

const ResultCount: React.FC<ResultCountProps> = ({ shown, total }) => {
  const unidade = (total ?? shown) === 1 ? 'item' : 'itens';
  return (
    <p className="c4u-result-count">
      Encontrados: <strong>{shown}</strong>
      {total !== undefined && ` de ${total}`} {unidade}
    </p>
  );
};

export default ResultCount;
